function messageTimestampValue(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value.toDate();
  if (typeof value?.toMillis === "function") return new Date(value.toMillis());
  if (typeof value?.seconds === "number") {
    const milliseconds = (value.seconds * 1000) + Math.floor(Number(value.nanoseconds || 0) / 1e6);
    return new Date(milliseconds);
  }
  return new Date(value);
}

export function getPersistedMessageCreatedAt(message = {}) {
  const date = messageTimestampValue(
    message.createdAt || message.sentAt || message.timestamp
  );
  return date && !Number.isNaN(date.getTime()) ? date.toISOString() : undefined;
}

export function mapSessionMessagesForDisplay(
  messages = [],
  { sessionId = "", participantLabel = "You" } = {}
) {
  return (Array.isArray(messages) ? messages : []).map((message, index) => {
    const createdAt = getPersistedMessageCreatedAt(message);
    const persistedId = String(message?.id || "").trim();
    return {
      id: persistedId || `${String(sessionId || "session")}:message:${index}`,
      sender:
        String(message?.role || "").toLowerCase() === "assistant" ||
        String(message?.sender || "").toLowerCase() === "nia"
          ? "NIA"
          : participantLabel,
      text: message?.content || message?.text || "",
      createdAt,
    };
  });
}

export function getMessageTimestampLabel(message = {}, locales, options = {}) {
  const date = messageTimestampValue(
    message.createdAt || message.sentAt || message.timestamp
  );
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(locales, {
    hour: "numeric",
    minute: "2-digit",
    ...options,
  });
}
